import { lazy } from 'react';
import { Route } from 'react-router-dom';
import { useModulEnabled } from '../../../auth';
import { route } from '../config';

const MeldungenListe = lazy(() => import('./MeldungenListe'));

export default function Meldungen() {
  const enabled = useModulEnabled('meldungenadmin');
  return enabled ? <Route path={`${route}/:meldungId?`} component={MeldungenListe} /> : null;
}
